import { QRsPage } from "@/screens/qrs";

export default function ProfileIndex() {
  return <QRsPage />;
}
